import { createID } from './object'

/**
 * 将按钮进行结构转换
 * @param {按钮数组} list
 * alias -> String 授权别名
 * after -> Object 后置动作 {action: {code:,name:}, parameter: {}, property: {}}
 * before -> Object 前置动作 {action: {code:,name:}, parameter: {}, property: {}}
 * code -> String 编码
 * depth -> Number 层级
 * doing -> Object 执行动作 {action: {code:,name:}, parameter: {}, property: {}}
 * enableExp  可点击表达式
 * icon -> String 图标
 * id -> String 位置值
 * lead -> String 上级编码
 * leaf -> Boolean 是否是叶子节点
 * name -> String 按钮显示文本
 * parent -> String 上级id
 * showExp -> String 显示表达式
 * style ->  String 样式控制，如；红色
 * title -> String 显示名字（当前没有使用）
 * children -> Array 下级节点
 */
export function buttonTransform(list, parent) {
  return list.map((im) => {
    return {
      code: im.code,
      name: im.name,
      icon: im.icon,
      doing: im.doing,
      after: im.after,
      before: im.before,
      enableExp: im.enableExp,
      showExp: im.showExp,
      leaf: im.leaf,
      style: im.style,
      depth: im.depth,
      id: im.id ?? createID(),
      lead: im.lead ?? parent?.code,
      parent: im.parent ?? parent?.id,
      title: im.title,
      alias: im.alias,
      children: buttonTransform(im.children ?? [], im),
    }
  })
}
